import React from 'react';
import './AniCard.css';

function AniCard({ image, imageHover, text }) {
  return (
    <div className="ani-card">
      <div className="card-image-container">
        <img src={image} alt={text} className="card-image" style={{ maxHeight: '100%', height: '350px', width: '100%', backgroundColor: '#f2f2f0', borderRadius: '20px' }} />
        {imageHover && <img src={imageHover} alt={text} className="card-image-hover" />}
      </div>
      <div className="card-text">{text}</div>
    </div>
  );
}

export default AniCard;
